import './style.css'

const Comment = props => {

    const className = "comment" + (props.isPrivate ? " comment_private" : "")
    const privateIcon = props.isPrivate ? <i className="comment__icon fa fa-eye-slash"></i> : null

    return (
        <div className={className}>
            <div className="comment__author">{props.user.name} {props.user.surname}</div>
            <div className="comment__date">{props.createdAt}</div>
            <div className="comment__text" dangerouslySetInnerHTML={{__html: props.text}} />
            {privateIcon}
        </div>
    )
}

export default Comment
